export enum SEARCH_FILTERS {
  PAGE = "page",
  SEARCH = "search",
  SHOW_VIRTUAL_EVENTS = "showVirtualEvents",
  SHOW_IN_PERSON_EVENTS = "showInPersonEvents",
  SHOW_PAST_EVENTS = "showPastEvents",
  SHOW_MYGWORK_EVENTS = "showMygworkEvents",
  NOT_FOUND = "not-found",
}
